import { BaseModel } from '~/models/baseModel';

export class VideoLinkModel extends BaseModel {
    public name:string;
    public vimeoId:string;
    public thumbnailUrl:string;
}
